// Festival & Event Constants

// Festival status progression
export const FESTIVAL_STATUSES = {
	NONE: "none",
	WANT: "want",
	MUST: "must",
	SAW_LIVE: "sawLive",
	SAW_STREAM: "sawStream",
} as const;

export type FestivalStatus =
	(typeof FESTIVAL_STATUSES)[keyof typeof FESTIVAL_STATUSES];

// Review rating scale
export const REVIEW_RATINGS = {
	MIN: 1,
	MAX: 5,
	DEFAULT: 3,
} as const;

// Set duration categories
export const SET_DURATION_CATEGORIES = {
	SHORT_10M: "10m-short",
	SHORT_15M: "15m-short",
	SHORT_20M: "20m-short",
	SHORT_25M: "25m-short",
	SHORT_30M: "30m-short",
	NORMAL: "normal",
} as const;

// Calendar display thresholds
export const CALENDAR_THRESHOLDS = {
	SHORT_SET_MINUTES: [10, 15, 20, 25, 30],
	MIN_SET_HEIGHT: 24,
	MIN_SET_WIDTH: 24,
	HOUR_HEIGHT: 160,
	HOUR_WIDTH: 240,
} as const;

// Set status types for scheduling
export const SET_STATUSES = {
	SAW_LIVE: "sawLive",
	SAW_STREAM: "sawStream",
	MUST_SEE: "mustSee",
	WANT_TO_SEE: "wantToSee",
	SCHEDULED: "scheduled",
	DEFAULT: "default",
} as const;

export type SetStatus = (typeof SET_STATUSES)[keyof typeof SET_STATUSES];

// Review filter types
export const REVIEW_FILTER_TYPES = {
	WANT: "want",
	MUST: "must",
	SAW_LIVE: "saw-live",
	SAW_STREAM: "saw-stream",
	RATED: "rated",
	LOVED: "loved",
} as const;

export type ReviewFilterConstant =
	(typeof REVIEW_FILTER_TYPES)[keyof typeof REVIEW_FILTER_TYPES];
